import { pickBy } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
export const groupCategoryPermissions = (state) => state.groupCategoryPermissions;
export const groupCategoryPermissionsResourcesSelector = (categoryId) => createSelector(groupCategoryPermissions, (group) => pickBy(group.resources, (group) => group.category === categoryId));
